import { Component, Inject } from '@angular/core';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

@Component({
  standalone: true,
  imports: [NgxExtendedPdfViewerModule, MatDialogModule, MatIconModule, MatProgressSpinnerModule],
  templateUrl: './dialog-visualizza-pdf.component.html',
  styleUrls: ['./dialog-visualizza-pdf.component.scss']
})
export class DialogVisualizzaPdfComponent {
  isLoaded = false;

  constructor(@Inject(MAT_DIALOG_DATA) public pdfUrl: any) {}

  static openWith(dialogHandler: MatDialog, pdfUrl: any) {
    dialogHandler.open(DialogVisualizzaPdfComponent, {
      width: '100vw',
      height: '100vh',
      maxWidth: '100vw',
      panelClass: 'no-padding',
      data: pdfUrl
    });
  }
}
